









































import Vue from 'vue';
import * as api from '@/api';
import { getProperties } from '../../api/Compare';
import { Properties, ComparisonProperties } from '../../api/types';

export default Vue.extend({
    data() {
        return {
            items: [] as Properties[],
            filterItems: [] as ComparisonProperties[],
        };
    },
    created() {
        this.$store.dispatch('getProductCompareList');
    },
    computed: {
        compareProductList() {
            return this.$store.state.compareProductList;
        },
    },
    watch: {
        compareProductList: {
            handler() {
                this.getProperties();
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        async getProperties() {
            const productIds = this.compareProductList.map((i) => i.productId).toString();
            if (productIds.length === 0) return;
            const res = await getProperties({ productIds });
            if (!api.error(res)) {
                this.items = res.data;
                let arr: ComparisonProperties[] = [];
                res.data.forEach((e) => {
                    arr = arr.concat(e.properties);
                });
                const newMap = new Map();
                console.log(this.items);
                console.log(arr);
                this.filterItems = arr.filter((a) => !newMap.has(a.name) && newMap.set(a.name, 1));
                console.log(this.filterItems);
            }
        },
        toDetail(data) {
            const path = `/product/${data.productId}`;
            this.$router.push({
                path,
            });
        },
    },
});

